import React, { useEffect, useState, useRef } from 'react';
import { ChevronDownIcon, CheckIcon } from 'lucide-react';
type CalendarView = 'month' | 'week' | 'day';
interface CalendarViewSelectorProps {
  currentView: CalendarView;
  onViewChange: (view: CalendarView) => void;
  isDark: boolean;
  availableViews?: CalendarView[];
}
export const CalendarViewSelector: React.FC<CalendarViewSelectorProps> = ({
  currentView,
  onViewChange,
  isDark,
  availableViews = ['day', 'week', 'month']
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const viewLabels: Record<CalendarView, string> = {
    day: 'Day',
    week: 'Week',
    month: 'Month'
  };
  // Click-outside detection
  useEffect(() => {
    if (!isOpen) return;
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setIsOpen(false);
      }
    };
    const timeoutId = setTimeout(() => {
      document.addEventListener('mousedown', handleClickOutside);
    }, 100);
    return () => {
      clearTimeout(timeoutId);
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);
  // Keyboard navigation
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Escape') {
      setIsOpen(false);
    }
  };
  return <div className="relative" ref={dropdownRef} data-id="element-561">
      <button onClick={() => setIsOpen(!isOpen)} onKeyDown={handleKeyDown} className={`px-4 py-2 rounded-md text-sm border-2 transition-colors flex items-center gap-2 ${isDark ? 'border-blue-500 text-blue-400 hover:bg-blue-500/10' : 'border-blue-600 text-blue-600 hover:bg-blue-50'}`} aria-expanded={isOpen} aria-haspopup="true" aria-label="Select calendar view" data-id="element-562">
        <span data-id="element-563">{viewLabels[currentView]}</span>
        <ChevronDownIcon className={`h-4 w-4 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} data-id="element-564" />
      </button>

      {isOpen && <div className={`absolute right-0 mt-2 w-40 rounded-lg shadow-xl z-50 ${isDark ? 'bg-navy-800 border border-navy-700' : 'bg-white border border-gray-200'}`} data-id="element-565">
          <div className="py-2" data-id="element-566">
            {availableViews.map(view => <button key={view} onClick={() => {
          onViewChange(view);
          setIsOpen(false);
        }} className={`w-full px-4 py-2.5 text-left text-sm transition-colors flex items-center justify-between ${view === currentView ? isDark ? 'bg-navy-700 text-blue-400 font-medium' : 'bg-blue-50 text-blue-600 font-medium' : isDark ? 'text-white hover:bg-navy-700/50' : 'text-gray-700 hover:bg-gray-50'}`} data-id="element-567">
                <span data-id="element-568">{viewLabels[view]}</span>
                {view === currentView && <CheckIcon className="h-4 w-4" data-id="element-569" />}
              </button>)}
          </div>
        </div>}
    </div>;
};